import React from 'react'

import { SxProps } from '@mui/material'

import { useGroup } from 'redux/hooks/Groups'
import { useGroupActions } from 'redux/actions/Groups'
import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Emoji from 'components_new/atoms/Emoji'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import { userIsPending } from 'utils/functions'
interface Props {
  sx?: SxProps
}

const Locked = (props: Props) => {
  const { sx } = props
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()

  const { tryInviteToGroup } = useGroupActions()

  const group = useGroup(id)
  const { account, loading: accountLoading } = useAccountSettings()

  if (!group || accountLoading) return null

  const handleAddUserToGroup = () => {
    tryInviteToGroup(group.id, account.id, group.is_private, false)
  }

  const isPending = userIsPending(group.pending, account.id)

  return (
    <Box sx={sx}>
      <EmptyPlaceholder
        actions={
          <>
            <Button to="/groups" variant="outlined">
              Tillbaka till grupper
            </Button>
            <Button disabled={isPending} onClick={handleAddUserToGroup}>
              {isPending
                ? t('global', 'request_sent')
                : t('groups', 'request_access')}
            </Button>
          </>
        }
        background={true}
        body="För att se innehållet i en privat grupp behöver du vara medlem."
        height={512}
        size="medium"
        title={
          <>
            Inget att se här... <Emoji name="lock" />
          </>
        }
      />
    </Box>
  )
}

export default Locked
